var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2258 5.1362C22.2258 3.95641 21.2694 3 20.0896 3H5.1362C3.95641 3 3 3.95641 3 5.1362V20.0896C3 21.2694 3.95641 22.2258 5.1362 22.2258H20.0896C21.2694 22.2258 22.2258 21.2694 22.2258 20.0896V5.1362ZM19.5556 13.8947V19.5556H16.5756V14.2899C16.5756 13.464 15.9061 12.7945 15.0803 12.7945C14.2578 12.7945 13.5956 13.4674 13.5956 14.2899V19.5556H10.6156V10.6156H13.5956V11.8012C14.1083 10.9681 15.1657 10.4127 16.0736 10.4127C17.9967 10.4127 19.5556 11.9716 19.5556 13.8947ZM7.14408 8.93815C8.13511 8.93815 8.93849 8.13477 8.93849 7.14375C8.93849 6.15041 8.13742 5.33866 7.14408 5.33866C6.14716 5.33866 5.33899 6.14682 5.33899 7.14375C5.33899 8.13708 6.15075 8.93815 7.14408 8.93815ZM8.62854 10.6161V19.5561H5.66991V10.6161H8.62854Z",
    fill: "#9096F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.2a8fae5f0fdf3bf9bae68aec82c1c471.svg";
export { ForwardRef as ReactComponent };